import { FinalPrice } from "../display/final-price";
import { DisplayPrice } from "../display/price";
import { Sheet } from "../fullscreen-sheet";
import { ICON_DTP } from "../../interfaces/icon";
import React, { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { useNavigate } from "react-router";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { cartCheckoutState, cartState } from "../../state";
import { checkProductDiscount, isIdentical } from "../../utils/product";
import { Box, Button, Text, useSnackbar } from "zmp-ui";
import { QuantityPicker } from "./quantity-picker";
import ImgDefault from "../../images/list-default.png";

export const ProductPicker = ({
  children,
  product,
  selected,
}) => {
  const { openSnackbar } = useSnackbar();
  const [visible, setVisible] = useState(false);
  const [quantity, setQuantity] = useState(1);
  const setCart = useSetRecoilState(cartState);
  const cart = useRecoilValue(cartState);

  useEffect(() => {
    if (selected) {
      setQuantity(selected.quantity);
    }
  }, [selected]);

  const addToCart = () => {
    if (product) {
      const indexProduct = cart.find((item) => +item.id === +product.id);
      if (!indexProduct) {
        setCart([...cart, product]);
      }
    }
    setVisible(false);
  };
  return (
    <>
      {children({
        open: addToCart,
        close: () => setVisible(false),
      })}
      {createPortal(
        <Sheet
          visible={visible}
          onClose={() => setVisible(false)}
          autoHeight
          style={{
            padding: "16px",
            borderTopLeftRadius: "1.5rem",
            borderTopRightRadius: "1.5rem",
          }}
          className={"cart-popup"}
        >
          {product && (
            <Box className="space-y-6 mt-2 p-0">
              <Box className="flex">
                <Box className="product-recommen__items-img aspect-square relative mr-[24px]">
                  <img
                    loading="lazy"
                    src={product.image || ImgDefault}
                    className="absolute left-0 right-0 top-0 bottom-0 w-full h-full object-cover object-center rounded-lg bg-skeleton"
                  />
                </Box>
                <Box
                  className="space-y-2"
                  style={{ width: "calc(100% - 132px)" }}
                >
                  <Text.Title>{product.title}</Text.Title>
                  {/* <Text>
                    <div
                      dangerouslySetInnerHTML={{
                        __html: product.short_description ?? "",
                      }}
                    ></div>
                  </Text> */}

                  <div className="special-product__price mt-2">
                    <Text
                      size="large"
                      className="font-medium text-primary special-product__price-value"
                    >
                      <FinalPrice>{product}</FinalPrice>
                    </Text>
                    {!!checkProductDiscount(product) && (
                      <Text
                        size="xxSmall"
                        className="line-through text-gray mr-[10px] special-product__price-discount"
                      >
                        <DisplayPrice>{product.price}</DisplayPrice>
                      </Text>
                    )}
                  </div>
                </Box>
                <p
                  className={"close-cart-popup"}
                  onClick={() => setVisible(false)}
                >
                  {ICON_DTP.close}
                </p>
              </Box>
              <Box className="space-y-5">
                <Box
                  className="flex quantity-box"
                  justifyContent="space-between"
                  alignItems="center"
                >
                  <p
                    style={{
                      fontWeight: "600",
                      fontSize: "14px",
                      width: "50%",
                    }}
                  >
                    Số lượng
                  </p>
                  <QuantityPicker value={quantity} onChange={setQuantity} />
                </Box>
                {selected ? (
                  <Button
                    variant={quantity > 0 ? "primary" : "secondary"}
                    type={quantity > 0 ? "highlight" : "neutral"}
                    fullWidth
                    onClick={addToCart}
                  >
                    {quantity > 0
                      ? selected
                        ? "Cập nhật giỏ hàng"
                        : "Thêm vào giỏ hàng"
                      : "Xoá"}
                  </Button>
                ) : (
                  <Button
                    disabled={!quantity}
                    variant="primary"
                    type="highlight"
                    fullWidth
                    onClick={addToCart}
                    className={"recommend-add-to_cart rounded-lg"}
                  >
                    Thêm vào giỏ hàng
                  </Button>
                )}
              </Box>
            </Box>
          )}
        </Sheet>,
        document.body
      )}
    </>
  );
};
export const CartProductPicker  = ({
  children,
  product,
  selected,
}) => {
  const [visible, setVisible] = useState(false);
  const [quantity, setQuantity] = useState(1);
  const setCart = useSetRecoilState(cartState);

  useEffect(() => {
    if (selected) {
      setQuantity(selected.quantity);
    }
  }, [selected]);

  const addToCart = () => {
    if (product) {
      setCart((cart) => {
        let res = [...cart];
        if (selected) {
          // updating an existing cart item, including quantity and size, or remove it if new quantity is 0
          const editing = cart.find(
            (item) =>
              item.product.id === product.id &&
              isIdentical(item.options, selected.options)
          );
          if (quantity === 0) {
            res.splice(cart.indexOf(editing), 1);
          } else {
            const existed = cart.find(
              (item, i) =>
                i !== cart.indexOf(editing) && item.product.id === product.id
            );
            res.splice(cart.indexOf(editing), 1, {
              ...editing,
              quantity: existed ? existed.quantity + quantity : quantity,
            });
            if (existed) {
              res.splice(cart.indexOf(existed), 1);
            }
          }
        } else {
          // adding new item to cart, or merging if it already existed before
          const existed = cart.find((item) => item.product.id === product.id);
          if (existed) {
            res.splice(cart.indexOf(existed), 1, {
              ...existed,
              quantity: existed.quantity + quantity,
            });
          } else {
            res = res.concat({ product, quantity });
          }
        }
        return res;
      });
    }
    setVisible(false);
  };
  return (
    <>
      {children({
        open: () => setVisible(true),
        close: () => setVisible(false),
      })}
      {createPortal(
        <Sheet
          visible={visible}
          onClose={() => setVisible(false)}
          autoHeight
          style={{
            padding: "16px",
            borderTopLeftRadius: "1.5rem",
            borderTopRightRadius: "1.5rem",
          }}
          className={"cart-popup"}
        >
          {product && (
            <Box className="space-y-6 mt-2 p-0">
              <Box className="flex">
                <Box className="product-recommen__items-img aspect-square relative mr-[24px]">
                  <img
                    loading="lazy"
                    src={product.image || ImgDefault}
                    className="absolute left-0 right-0 top-0 bottom-0 w-full h-full object-cover object-center rounded-lg bg-skeleton"
                  />
                </Box>
                <Box
                  className="space-y-2"
                  style={{ width: "calc(100% - 132px)" }}
                >
                  <Text.Title>{product.title}</Text.Title>
                  <Text>
                    <div
                      dangerouslySetInnerHTML={{
                        __html: product.short_description ?? "",
                      }}
                    ></div>
                  </Text>

                  <div className="special-product__price mt-2">
                    <Text
                      size="large"
                      className="font-medium text-primary special-product__price-value"
                    >
                      <FinalPrice>{product}</FinalPrice>
                    </Text>
                    <Text
                      size="xxSmall"
                      className="line-through text-gray mr-[10px] special-product__price-discount"
                    >
                      <DisplayPrice>{product.price_discount}</DisplayPrice>
                    </Text>
                  </div>
                </Box>
                <p
                  className={"close-cart-popup"}
                  onClick={() => setVisible(false)}
                >
                  {ICON_DTP.close}
                </p>
              </Box>
              <Box className="space-y-5">
                <Box
                  className="flex quantity-box"
                  justifyContent="space-between"
                  alignItems="center"
                >
                  <p
                    style={{
                      fontWeight: "600",
                      fontSize: "14px",
                      width: "50%",
                    }}
                  >
                    Số lượng
                  </p>
                  <QuantityPicker
                    value={quantity}
                    onChange={setQuantity}
                    width="116px"
                  />
                </Box>
                {selected ? (
                  <Button
                    variant={quantity > 0 ? "primary" : "secondary"}
                    type={quantity > 0 ? "highlight" : "neutral"}
                    fullWidth
                    onClick={addToCart}
                  >
                    {quantity > 0
                      ? selected
                        ? "Cập nhật giỏ hàng"
                        : "Thêm vào giỏ hàng"
                      : "Xoá"}
                  </Button>
                ) : (
                  <Button
                    disabled={!quantity}
                    variant="primary"
                    type="highlight"
                    fullWidth
                    onClick={addToCart}
                    className={"recommend-add-to_cart"}
                  >
                    Thêm vào giỏ hàng
                  </Button>
                )}
              </Box>
            </Box>
          )}
        </Sheet>,
        document.body
      )}
    </>
  );
};

export const BuyNowProductPicker = ({
  children,
  product,
  selected,
}) => {
  const { openSnackbar } = useSnackbar();
  const [visible, setVisible] = useState(false);
  const [quantity, setQuantity] = useState(1);
  const setCart = useSetRecoilState(cartState);
  const setCartCheckout = useSetRecoilState(cartCheckoutState);
  const navigate = useNavigate();
  useEffect(() => {
    if (selected) {
      setQuantity(selected.quantity);
    }
  }, [selected]);

  const addToCartCheckout = () => {
    if (product) {
      // setCart((cart) => {
      //   let res = [...cart];
      //   if (selected) {
      //     // updating an existing cart item, including quantity and size, or remove it if new quantity is 0
      //     const editing = cart.find(
      //       (item) =>
      //         item.product.id === product.id &&
      //         isIdentical(item.options, selected.options),
      //     )!;
      //     if (quantity === 0) {
      //       res.splice(cart.indexOf(editing), 1);
      //     } else {
      //       const existed = cart.find(
      //         (item, i) =>
      //           i !== cart.indexOf(editing) && item.product.id === product.id,
      //       )!;
      //       res.splice(cart.indexOf(editing), 1, {
      //         ...editing,
      //         quantity: existed ? existed.quantity + quantity : quantity,
      //       });
      //       if (existed) {
      //         res.splice(cart.indexOf(existed), 1);
      //       }
      //     }
      //   } else {
      //     // adding new item to cart, or merging if it already existed before
      //     const existed = cart.find((item) => item.product.id === product.id);
      //     if (existed) {
      //       res.splice(cart.indexOf(existed), 1, {
      //         ...existed,
      //         quantity: existed.quantity + quantity,
      //       });
      //     } else {
      //       res = res.concat({ product, quantity });
      //     }
      //   }
      //   return res;
      // });
      setCartCheckout({
        type: product.type,
        data: [
          {
            product,
            quantity,
            options: null,
          },
        ],
      });
    }
    setVisible(false);

    navigate("/checkout");
  };
  return (
    <>
      {children({
        open: () => setVisible(true),
        close: () => setVisible(false),
      })}
      {createPortal(
        <Sheet
          visible={visible}
          onClose={() => setVisible(false)}
          autoHeight
          style={{
            padding: "16px",
            borderTopLeftRadius: "1.5rem",
            borderTopRightRadius: "1.5rem",
          }}
          className={"cart-popup"}
        >
          {product && (
            <Box className="space-y-6 mt-2 p-0">
              <Box className="flex">
                <Box className="product-recommen__items-img aspect-square relative mr-[24px]">
                  <img
                    loading="lazy"
                    src={product.image || ImgDefault}
                    className="absolute left-0 right-0 top-0 bottom-0 w-full h-full object-cover object-center rounded-lg bg-skeleton"
                  />
                </Box>
                <Box
                  className="space-y-2"
                  style={{ width: "calc(100% - 132px)" }}
                >
                  <Text.Title>{product.title}</Text.Title>
                  {/* <Text>
                    <div
                      dangerouslySetInnerHTML={{
                        __html: product.short_description ?? "",
                      }}
                    ></div>
                  </Text> */}

                  <div className="special-product__price mt-2">
                    <Text
                      size="large"
                      className="font-medium text-primary special-product__price-value"
                    >
                      <FinalPrice>{product}</FinalPrice>
                    </Text>
                    {!!checkProductDiscount(product) && (
                      <Text
                        size="xxSmall"
                        className="line-through text-gray mr-[10px] special-product__price-discount"
                      >
                        <DisplayPrice>{product.price_discount}</DisplayPrice>
                      </Text>
                    )}
                  </div>
                </Box>
                <p
                  className={"close-cart-popup"}
                  onClick={() => setVisible(false)}
                >
                  {ICON_DTP.close}
                </p>
              </Box>
              <Box className="space-y-5">
                <Box
                  className="flex quantity-box"
                  justifyContent="space-between"
                  alignItems="center"
                >
                  <p
                    style={{
                      fontWeight: "600",
                      fontSize: "14px",
                      width: "50%",
                    }}
                  >
                    Số lượng
                  </p>
                  <QuantityPicker
                    value={quantity}
                    onChange={setQuantity}
                    width="116px"
                  />
                </Box>
                <Button
                  disabled={!quantity}
                  variant="primary"
                  type="highlight"
                  fullWidth
                  onClick={addToCartCheckout}
                  className={"recommend-add-to_cart rounded-lg"}
                >
                  Mua ngay
                </Button>
              </Box>
            </Box>
          )}
        </Sheet>,
        document.body
      )}
    </>
  );
};
